<template>
  <div v-if="attendanceClass && childrenClass && chatSummary">
    <v-subheader class="attendance-list-header">
      {{ clas.className }}
      <template v-if="myClass && myClass.classId === clas.classId">
        <div class="primary--text ml-2">{{ $t('attendance.inCharge') }}</div>
      </template>
      <v-spacer></v-spacer>
      {{ chatSummary.presentChildrenCount }}/{{ chatSummary.totalChildrenCount }}
    </v-subheader>
    <v-list-item
      v-for="(child, index) in childrenClass.children"
      :key="index"
      :to="`/communication/chat/${child.childId}`"
    >
      <ChildrenAttendanceList
        :child="child"
        :attendanceClass="attendanceClass"
        :chatSummary="chatSummary"
      />
    </v-list-item>
  </div>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';
import ChildrenAttendanceList from '@/components/atoms/ChildrenAttendanceList.vue';
import { attendanceModule } from '@/store/dataModules/attendanceModule';
import { childrenModule } from '@/store/dataModules/childrenModule';
import VueLoading from '@/components/pages/Loding.vue';

import { ChatSummaryResponse, NurseryClassResponse } from 'chaild-api/lib/index';
import { GetAttendanceSearchResponse, GetChildrenResponse } from '@/model/Response';

import LocalDataService from '@/service/LocalDataService';
import dayjs from 'dayjs';
import { chatModule } from '@/store/dataModules/chatModule';

export default defineComponent({
  components: {
    VueLoading,
    ChildrenAttendanceList,
  },
  data: () => {
    return {
      attendanceClass: null as GetAttendanceSearchResponse | null,
      childrenClass: null as GetChildrenResponse | null,
      fetchLoading: false,
    };
  },
  props: {
    clas: {
      type: Object as PropType<NurseryClassResponse>,
      required: true,
    },
    myClass: {
      type: Object as PropType<any>,
    },
  },
  computed: {
    attendancesByClass(): GetAttendanceSearchResponse[] {
      return attendanceModule.attendancesByClass;
    },
    chatSummary() {
      if (chatModule.chatSummary) {
        const chatSummary = chatModule.chatSummary.summaries;
        const find = chatSummary.find(summary => summary.classId === this.clas.classId);
        if (find) {
          return find;
        }
      }
      return null;
    },
  },
  methods: {
    childAttendance(childId?: string) {
      if (childId) {
        console.log(childId);
        return childId;
      }
    },
  },
  async mounted() {
    this.fetchLoading = true;
    const today = dayjs().format('YYYY-MM-DD');
    const user = LocalDataService.getUser();
    if (user && today) {
      let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
      if (!nurserySchool) {
        nurserySchool = user.nurserySchools[0];
      }
      const nurseryId = nurserySchool.nurseryId;
      this.attendanceClass = await attendanceModule.searchAttendanceByClass({
        date: today,
        nurseryId: nurseryId,
        classId: this.clas.classId,
      });
      this.childrenClass = await childrenModule.getChildren({
        classId: this.clas.classId,
        nurseryId
      });
    }
    await this.$nextTick();
    this.fetchLoading = false;
  },
});
</script>
<style lang="scss" scoped>
.message-btn {
  line-height: 1.2rem;
}

.attendance-list-header {
  background-color: #f5f6f6;
  height: 32px !important;
  font-weight: bold !important;
}
</style>
